var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            "panel-title": "Thông tin chung",
            "panel-subtitle": "Vui lòng điền đầy đủ thông tin",
            "panel-icon": "el-icon-document-add",
            visible: _vm.dialogVisible,
            width: "90%",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "2vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "tab-infor-button" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "medium" },
                          on: {
                            click: function ($event) {
                              return _vm.closeDialogByButton(
                                "formAllTabClassMenu"
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-circle-close" }),
                          _c("span", [_vm._v("Đóng")]),
                        ]
                      ),
                      _vm.checkPermission(["studentQuality_menu_update"])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "medium",
                                loading: _vm.loadingButton,
                                mini: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("formAllTabClassMenu")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-circle-check" }),
                              _c("span", [_vm._v("Lưu")]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              ref: "formAllTabClassMenu",
              attrs: {
                "label-width": "140px",
                model: _vm.tabClassMenuInWeekClass,
                "label-position": "left",
              },
            },
            [
              _c(
                "h2",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    display: "inline-block",
                  },
                },
                [_vm._v("Thực đơn lớp: " + _vm._s(_vm.className) + " ")]
              ),
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeNameTab,
                    callback: function ($$v) {
                      _vm.activeNameTab = $$v
                    },
                    expression: "activeNameTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 2", name: "monday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.tabClassMenuInWeekClass[0]
                                  .tabClassMenuDayClassList,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            scope.row.urlImgMenuWeb
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "container_image",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: scope.row
                                                          .urlImgMenuWeb,
                                                        alt: "Ảnh minh hoạ",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "container_image_task",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "btn_delete_image",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteImageMenu(
                                                                  scope.row,
                                                                  _vm
                                                                    .tabClassMenuInWeekClass[0],
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-close",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Tải ảnh lên",
                                  align: "center",
                                  width: "350",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-upload", {
                                          ref: "uploadImageMenu",
                                          staticClass: "upload_image",
                                          attrs: {
                                            action: "#",
                                            "file-list": _vm.fileListImage,
                                            "list-type": "picture-card",
                                            "on-preview":
                                              _vm.handlePictureCardPreview,
                                            "on-remove": () =>
                                              _vm.handleRemoveImage(scope, 0),
                                            "on-change": (value) =>
                                              _vm.handleChangeImage(
                                                scope,
                                                value,
                                                0
                                              ),
                                            "auto-upload": false,
                                            multiple: false,
                                            accept: "image/*",
                                            limit: 1,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "trigger",
                                                fn: function () {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "el-icon-plus",
                                                        },
                                                        [_vm._v("Thêm ảnh")]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              0
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2930987014
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 3", name: "tuesday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.tabClassMenuInWeekClass[1]
                                  .tabClassMenuDayClassList,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            scope.row.urlImgMenuWeb
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "container_image",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: scope.row
                                                          .urlImgMenuWeb,
                                                        alt: "Ảnh minh hoạ",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "container_image_task",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "btn_delete_image",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteImageMenu(
                                                                  scope.row,
                                                                  _vm
                                                                    .tabClassMenuInWeekClass[1],
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-close",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Tải ảnh lên",
                                  align: "center",
                                  width: "350",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-upload", {
                                          ref: "uploadImageMenu",
                                          staticClass: "upload_image",
                                          attrs: {
                                            action: "#",
                                            "file-list": _vm.fileListImage,
                                            "list-type": "picture-card",
                                            "on-preview":
                                              _vm.handlePictureCardPreview,
                                            "on-remove": () =>
                                              _vm.handleRemoveImage(scope, 1),
                                            "on-change": (value) =>
                                              _vm.handleChangeImage(
                                                scope,
                                                value,
                                                1
                                              ),
                                            "auto-upload": false,
                                            multiple: false,
                                            accept: "image/*",
                                            limit: 1,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "trigger",
                                                fn: function () {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "el-icon-plus",
                                                        },
                                                        [_vm._v("Thêm ảnh")]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              1
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2724730695
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 4", name: "wednesday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.tabClassMenuInWeekClass[2]
                                  .tabClassMenuDayClassList,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            scope.row.urlImgMenuWeb
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "container_image",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: scope.row
                                                          .urlImgMenuWeb,
                                                        alt: "Ảnh minh hoạ",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "container_image_task",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "btn_delete_image",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteImageMenu(
                                                                  scope.row,
                                                                  _vm
                                                                    .tabClassMenuInWeekClass[2],
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-close",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Tải ảnh lên",
                                  align: "center",
                                  width: "350",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-upload", {
                                          ref: "uploadImageMenu",
                                          staticClass: "upload_image",
                                          attrs: {
                                            action: "#",
                                            "file-list": _vm.fileListImage,
                                            "list-type": "picture-card",
                                            "on-preview":
                                              _vm.handlePictureCardPreview,
                                            "on-remove": () =>
                                              _vm.handleRemoveImage(scope, 2),
                                            "on-change": (value) =>
                                              _vm.handleChangeImage(
                                                scope,
                                                value,
                                                2
                                              ),
                                            "auto-upload": false,
                                            multiple: false,
                                            accept: "image/*",
                                            limit: 1,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "trigger",
                                                fn: function () {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "el-icon-plus",
                                                        },
                                                        [_vm._v("Thêm ảnh")]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              2
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1419767556
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 5", name: "thursday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.tabClassMenuInWeekClass[3]
                                  .tabClassMenuDayClassList,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            scope.row.urlImgMenuWeb
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "container_image",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: scope.row
                                                          .urlImgMenuWeb,
                                                        alt: "Ảnh minh hoạ",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "container_image_task",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "btn_delete_image",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteImageMenu(
                                                                  scope.row,
                                                                  _vm
                                                                    .tabClassMenuInWeekClass[3],
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-close",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Tải ảnh lên",
                                  align: "center",
                                  width: "350",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-upload", {
                                          ref: "uploadImageMenu",
                                          staticClass: "upload_image",
                                          attrs: {
                                            action: "#",
                                            "file-list": _vm.fileListImage,
                                            "list-type": "picture-card",
                                            "on-preview":
                                              _vm.handlePictureCardPreview,
                                            "on-remove": () =>
                                              _vm.handleRemoveImage(scope, 3),
                                            "on-change": (value) =>
                                              _vm.handleChangeImage(
                                                scope,
                                                value,
                                                3
                                              ),
                                            "auto-upload": false,
                                            multiple: false,
                                            accept: "image/*",
                                            limit: 1,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "trigger",
                                                fn: function () {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "el-icon-plus",
                                                        },
                                                        [_vm._v("Thêm ảnh")]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              3
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3847270981
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 6", name: "friday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.tabClassMenuInWeekClass[4]
                                  .tabClassMenuDayClassList,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            scope.row.urlImgMenuWeb
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "container_image",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: scope.row
                                                          .urlImgMenuWeb,
                                                        alt: "Ảnh minh hoạ",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "container_image_task",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "btn_delete_image",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteImageMenu(
                                                                  scope.row,
                                                                  _vm
                                                                    .tabClassMenuInWeekClass[4],
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-close",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Tải ảnh lên",
                                  align: "center",
                                  width: "350",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-upload", {
                                          ref: "uploadImageMenu",
                                          staticClass: "upload_image",
                                          attrs: {
                                            action: "#",
                                            "file-list": _vm.fileListImage,
                                            "list-type": "picture-card",
                                            "on-preview":
                                              _vm.handlePictureCardPreview,
                                            "on-remove": () =>
                                              _vm.handleRemoveImage(scope, 4),
                                            "on-change": (value) =>
                                              _vm.handleChangeImage(
                                                scope,
                                                value,
                                                4
                                              ),
                                            "auto-upload": false,
                                            multiple: false,
                                            accept: "image/*",
                                            limit: 1,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "trigger",
                                                fn: function () {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "el-icon-plus",
                                                        },
                                                        [_vm._v("Thêm ảnh")]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              4
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      662038018
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 7", name: "saturday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.tabClassMenuInWeekClass[5]
                                  .tabClassMenuDayClassList,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            scope.row.urlImgMenuWeb
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "container_image",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: scope.row
                                                          .urlImgMenuWeb,
                                                        alt: "Ảnh minh hoạ",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "container_image_task",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "btn_delete_image",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteImageMenu(
                                                                  scope.row,
                                                                  _vm
                                                                    .tabClassMenuInWeekClass[5],
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-close",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Tải ảnh lên",
                                  align: "center",
                                  width: "350",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-upload", {
                                          ref: "uploadImageMenu",
                                          staticClass: "upload_image",
                                          attrs: {
                                            action: "#",
                                            "file-list": _vm.fileListImage,
                                            "list-type": "picture-card",
                                            "on-preview":
                                              _vm.handlePictureCardPreview,
                                            "on-remove": () =>
                                              _vm.handleRemoveImage(scope, 5),
                                            "on-change": (value) =>
                                              _vm.handleChangeImage(
                                                scope,
                                                value,
                                                5
                                              ),
                                            "auto-upload": false,
                                            multiple: false,
                                            accept: "image/*",
                                            limit: 1,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "trigger",
                                                fn: function () {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "el-icon-plus",
                                                        },
                                                        [_vm._v("Thêm ảnh")]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              5
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1711566659
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }